// extracted by mini-css-extract-plugin
export default {"file":"File_file__zcHWb","close":"File_close__mAFPq"};